import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { ArrowForwardIosRounded, InfoRounded } from '@material-ui/icons';
import { useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { formatDate224 } from '@webapps/utils';
import FormMapper from 'components/FormMapper';
import { updateStudentContract, updateStudentCoordonnes } from '@webapps/business';
import { studentFormConfig } from 'config/forms';
import { useEffect, useState } from 'react';

const Student = ({ opcoRecord, refetch, sectionKey, reportInvalid }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const [expanded, setExpanded] = useState(false);
  const { addToast } = useToast();

  const {
    isSuccess,
    error,
    mutateAsync: mutateUpdateStudentContract,
  } = useMutation(updateStudentContract);

  const {
    mutateAsync: mutateUpdateStudentInfo,
  } = useMutation(updateStudentCoordonnes);

  const {
    component: formComponent,
    invalidCount,
    validCount,
    totalFields,
  } = FormMapper({
    formConfig: studentFormConfig,
    info: opcoRecord,
    onSubmit: async (values) => {
      await mutateUpdateStudentContract({ id: opcoRecord?.individual?.id, data: {...values} });
      await mutateUpdateStudentInfo({ id: opcoRecord?.individual?.id, data: {...values} });
    },
    settings: { submitType: 'onBlur' },
  });

  useEffect(() => {
    reportInvalid(sectionKey, invalidCount);
  }, [invalidCount]);

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Informations mises à jour avec succès',
      });
      refetch();
    } else if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccess, error]);

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      className={cx(
        invalidCount > 0 && !expanded && classes.error,
        !expanded && invalidCount === 0 && classes.hover
      )}
    >
      <AccordionSummary expandIcon={<ArrowForwardIosRounded className={invalidCount > 0 && !expanded ? classes.arrowError : classes.arrow} />} >
        <div className={cx(global.fracjb, css({ width: '100%' }))}>
          <h1 className={cx(global.title, global.blueBar, css({ margin: 0 }))}>
            Partie Apprenti{' '} <span className={classes.span}> ({validCount}/{totalFields} champs complets)</span>
          </h1>
          <div className={cx(global.frac, css({ marginRight: '14px', color: '#152652' }))}>
            <InfoRounded className={classes.icon} /> Dernières modification {formatDate224(opcoRecord?.individual?.individualContract?.lastUpdate)}
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {formComponent}
      </AccordionDetails>
    </Accordion>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  error: {
    backgroundColor: '#FBD3D5',
    color: '#F50057',
    border: '1px solid #F50057',
    '& h1': {
      color: '#F50057',
      borderColor: '#F50057',
    },
  },
  hover: {
    '&:hover h1': {
      color: '#0060F9',
    },
  },
  span: {
    fontWeight: 500,
  },
  icon: {
    color: '#0060F9',
    fontSize: '16px',
    marginRight: '6px',
  },
  arrow: {
    color: '#5D75A8',
    fontSize: '20px',
    transform: 'rotate(90deg)',
  },
  arrowError: {
    color: '#F50057',
    fontSize: '20px',
    transform: 'rotate(90deg)',
  },
});

export default Student;